export interface PasswordCheck {
  valid: boolean;
  errors: string[];
}

const MIN_LENGTH = 12;

export function validatePassword(password: string): PasswordCheck {
  const errors: string[] = [];

  if (password.length < MIN_LENGTH) {
    errors.push(`At least ${MIN_LENGTH} characters`);
  }
  if (!/[a-z]/.test(password)) {
    errors.push('At least one lowercase letter');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('At least one uppercase letter');
  }
  if (!/[0-9]/.test(password)) {
    errors.push('At least one number');
  }
  if (!/[^a-zA-Z0-9]/.test(password)) {
    errors.push('At least one special character');
  }

  return { valid: errors.length === 0, errors };
}
